module.exports = __webpack_public_path__ + "static/iom-208f772fa2fe069a0c37a6cc2e51aebb.jpg";